import React from "react";

export default function IconRight() {
  return (
    <svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.77078 4.00169L0.777998 1.00878C0.695592 0.926569 0.650259 0.81665 0.650259 0.699447C0.650259 0.582179 0.695592 0.472325 0.777998 0.389984L1.04024 0.12787C1.12252 0.0453984 1.2325 0 1.34971 0C1.46691 0 1.57676 0.0453984 1.6591 0.12787L5.22249 3.69119C5.30515 3.77379 5.35042 3.88416 5.3501 4.0015C5.35042 4.11935 5.30522 4.22959 5.22249 4.31226L1.66242 7.87213C1.58008 7.9546 1.47023 8 1.35296 8C1.23575 8 1.1259 7.9546 1.04349 7.87213L0.781316 7.61002C0.610714 7.43941 0.610714 7.16169 0.781316 6.99115L3.77078 4.00169Z"
        fill="white"
      />
    </svg>
  );
}
